import SaveTrasladoInventario from "@/erp/inventario/transferencia-inventario/shared/componente/save_traslado/SaveTrasladoInventario";
import { useFetchGetByIdNotificacionInventario, useFetchGetNotificacionInventario } from "@/shared/actions";
import { LoaderComponent } from "@/shared/components/ui";
import { ITransitoInventario } from "@/shared/interfaces/erp/administration/transito_inventario.interface";
import { useParams } from "react-router-dom";

export const CreateNotificacionTrasladoPage = () => {
   const { id } = useParams();

  const {
    data,
    isLoading,
  } = useFetchGetByIdNotificacionInventario(id!)  


  if (isLoading) return <LoaderComponent />

  return (
    <SaveTrasladoInventario
      dataTransitoInventario={data?.data! as unknown as ITransitoInventario}
      title="Transferencia Inventario"
      modulo="NOTIFICACION"
      notificacion_id={data?.data.id_notificacion_inventario ?? null}
    />
  )
}